<template>
  <div>
    <!-- <el-button type="primary">操作盘</el-button> -->

    <hr style="height: 1px;transform: scale(0.5);"><hr>


  </div>
</template>

<script>

  export default{
    methods: {
      getJson(){
        
      }
    },
    activated() {
      
    }
  }
</script>

<style>
  .el-steps--simple{
    padding: 13px 0;
  }
  .processDetail{
    /* border: 1px solid #0000FF; */
    margin-top: 10px;
    padding: 10px 0;
  }
</style>
